import { Text } from '../../../';
import { TextLink } from '../../../';
import { TableCommonStyles } from '../../common-styles';

export const FilterHeader = ({ render, label, onClick, disabled }) => {
  const filterSectionHeaderStyles = TableCommonStyles.tableFilterStyles({
    type: 'filterSectionHeader',
  });

  return (
    <section css={filterSectionHeaderStyles}>
      <Text weight='semibold'>{label ?? render('Header')}</Text>
      <TextLink disabled={disabled} weight='semibold' onClick={onClick}>
        Clear
      </TextLink>
    </section>
  );
};
